import { render, staticRenderFns } from "./MentoringLanguages.vue?vue&type=template&id=cb2abfc8&"
import script from "./MentoringLanguages.vue?vue&type=script&lang=js&"
export * from "./MentoringLanguages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports